// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
visiba-step {
  background-color: var(--c_backgroundBox);
  display: flex;
  width: 100%;
  padding: 20px 40px 16px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-bottom: 2px;
  flex-wrap: wrap;
}
@media screen and (min-width: 900px) {
  visiba-step {
    flex-direction: row;
  }
}
visiba-step .step {
  display: flex;
  align-items: center;
  margin: 0 10px;
  color: rgba(var(--c_textBody), 0.54285714);
}
visiba-step .step visiba-svg {
  width: 10px;
  margin-left: 20px;
  vertical-align: middle;
  flex-shrink: 0;
}
visiba-step .step visiba-svg .fill {
  fill: rgba(var(--c_textBody), 0.54285714);
}
visiba-step .step.done, visiba-step .step.current {
  color: var(--c_mainColorDark);
}
visiba-step .step.done visiba-svg .fill {
  fill: var(--c_mainColorDark);
}
visiba-step .step.current span {
  border-bottom: 2px solid var(--c_mainColorDark);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
